import OptionList from "@JohnLewisPartnership/jl-design-system/dist/components/option/OptionList";
import RadioButton from "@JohnLewisPartnership/jl-design-system/dist/components/radio-button/RadioButton";
import React, { useEffect, useState } from "react";
import styles from "./email-form.module.scss";
import { useLiveChat } from "@/hooks";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import ContactChat from "components/contact-details-box/contact-methods/contact-chat/ContactChat";

const map = new Map();
map.set("Refund", "The customer is requesting a REFUND.");
map.set("Replacement", "The customer is requesting a REPLACEMENT.");
map.set("Notsure", "The customer isn't sure if they would like a refund or replacement.");

const options = [
  { value: "Refund", label: "Refund" },
  { value: "Replacement", label: "Replacement (to same address)" },
  { value: "Notsure", label: "Other (including replacement to new address)" },
];

const PreferredResolutionWithChatWidget = ({ value, onPrefResChange, handleEnableForm, location }) => {
  const { chatConfig, isLoading } = useLiveChat("placeEditCancelOrder");
  const [showContinueToEmail, setShowContinueToEmail] = useState(true);

  useEffect(() => {
    if (chatConfig?.chat?.open === false && value === "Replacement") {
      handleEnableForm(true);
    }
  }, [chatConfig?.chat?.open, value]);

  const handleChange = e => {
    onPrefResChange(e.target.value);
    if (e.target.value === "Replacement") {
      setShowContinueToEmail(true);
      handleEnableForm(false);
    } else {
      setShowContinueToEmail(false);
      handleEnableForm(true);
    }
  };

  const handleContinue = () => {
    setShowContinueToEmail(false);
    handleEnableForm(true);
  };

  return (
    <div>
      <label htmlFor="radio-button-group" className={styles["customLabel"]}>
        Preferred resolution
      </label>
      <OptionList className={styles["radio-group-label"]} name="radio-button-group" isButtonList={true}>
        {options.map(option => (
          <RadioButton
            key={option.value}
            onChange={handleChange}
            value={option.value}
            label={option.label}
            checked={option.value === value}
          />
        ))}
      </OptionList>
      {value === "Replacement" && !isLoading && chatConfig?.chat?.open && (
        <>
          <div className={styles["live-chat-container"]}>
            <h2 className={styles.title}>Request a replacement through live chat</h2>
            <p className={styles.description}>
              Live chat is the quickest way to order a replacement. Alternatively, email can take up to 24 hours for a
              response.
            </p>
            <ContactChat
              config={chatConfig.chat}
              displayOpeningHours={true}
              displayDescriptionParagraph={false}
              displayHeading={false}
              location={location}
            />
          </div>
          {showContinueToEmail && (
            <div className={styles.continueToEmail}>
              <UnderlinedButton onClick={handleContinue} className={styles.continue}>
                Continue to email
              </UnderlinedButton>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export const getPreferredResolutionDescription = key => map.get(key) || "";

export default PreferredResolutionWithChatWidget;
